import React, { useState } from "react";
import Explainer from "../ExplainerModal";
import plmProcess from "../FlowCharts/PLM-process.png"; // Importing the flowchart
import policyImplementation from "../FlowCharts/Policy-Implementation.png"

const PolicyLifecycleManagementExplainer = () => {
  const [isPlmZoomed, setIsPlmZoomed] = useState(false);
  const [isPolicyImplementationZoomed, setIsPolicyImplementationZoomed] = useState(false);

  return (
    <Explainer
      title="📜 Policy Lifecycle Management Explainer"
      content={
        <>
          <p>
            The <strong>Policy Lifecycle Management</strong> section enables users to track policy progress through key stages, monitor delays, and update relevant details.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            ⏳ Policy Stage Time Tracker
          </h3>
          <p>
            This feature measures how long a policy stays in each stage, helping users identify bottlenecks and improve efficiency.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            📝 Responding to Milestones
          </h3>
          <p>
            Clicking on the <strong>"Respond to Milestones"</strong> button allows users to provide updates on the current stage milestones for a specific policy.
          </p>

          <h3 style={{ fontSize: "20px", fontWeight: "bold", marginTop: "20px", color: "#222" }}>
            📌 Policy Lifecycle Stages & Milestones
          </h3>
          <ul>
            <li><strong>1️⃣ Initiation:</strong> Identifying and prioritizing policy challenges.</li>
            <li><strong>2️⃣ Development:</strong> Drafting policy documents and conducting impact assessments.</li>
            <li><strong>3️⃣ Validation:</strong> Refining policy drafts through stakeholder engagement.</li>
            <li><strong>4️⃣ Approval:</strong> Policy is reviewed and approved by the cabinet or relevant authority.</li>
            <li><strong>5️⃣ Legislation:</strong> Parliamentary review, public hearings, and presidential assent.</li>
            <li><strong>6️⃣ Implementation:</strong> Policy enforcement, monitoring, and evaluation.</li>
          </ul>

          <h3 style={{ fontSize: "20px", fontWeight: "bold", marginTop: "20px", color: "#137A08" }}>
            🏆 What is a Policy Win?
          </h3>
          <p>
            A <strong>Policy Win</strong> is achieved when a policy successfully completes all the milestones in the <strong>Legislation</strong> stage. This marks a significant milestone, as the policy ready for implementation.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            🔄 Policy Lifecycle Management Process Flowchart
          </h3>
          <div style={{ position: "relative", display: "inline-block" }}>
            <img
              src={plmProcess}
              alt="Policy Lifecycle Management Process Flowchart"
              style={{ width: "100%", borderRadius: "8px", marginTop: "10px", cursor: "pointer" }}
              onClick={() => setIsPlmZoomed(true)}
            />
            <button
              onClick={() => setIsPlmZoomed(true)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "rgba(0, 0, 0, 0.7)",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                fontSize: "20px",
                cursor: "pointer"
              }}
            >
              🔍 <span style={{ fontSize: "10px", color: "black" }}>Zoom</span>
            </button>
          </div>

          {isPlmZoomed && (
            <div
              style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: "1000"
              }}
              onClick={() => setIsPlmZoomed(false)}
            >
              <img
                src={plmProcess}
                alt="Zoomed Policy Lifecycle Management Process Flowchart"
                style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: "8px" }}
              />
            </div>
          )}

        <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            ⚙️ Policy Implementation Model
        </h3>

          <div style={{ position: "relative", display: "inline-block" }}>
            {/* Policy Implementation Image */}
            <img
              src={policyImplementation}
              alt="Policy Implementation Model"
              style={{ width: "100%", borderRadius: "8px", marginTop: "10px", cursor: "pointer" }}
              onClick={() => setIsPolicyImplementationZoomed(true)}
            />
            <button
              onClick={() => setIsPolicyImplementationZoomed(true)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "rgba(0, 0, 0, 0.7)",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                fontSize: "20px",
                cursor: "pointer"
              }}
            >
              🔍 <span style={{ fontSize: "10px", color: "black" }}>Zoom</span>
            </button>
          </div>

          {/* Zoomed Image Modal for Policy Implementation */}
          {isPolicyImplementationZoomed && (
            <div
              style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: "1000"
              }}
              onClick={() => setIsPolicyImplementationZoomed(false)}
            >
              <img
                src={policyImplementation}
                alt="Zoomed Policy Implementation Model"
                style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: "8px" }}
              />
            </div>
          )}
        </>
      }
    />
  );
};

export default PolicyLifecycleManagementExplainer;
